import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'
import convertInstructor from 'Assets/Mascots/mascot-03.jpg'
import { useState } from 'react'
import { youtubeToSummary, getYoutubeUrlInfo } from 'Contexts/General/General.interactor'
import { PageHeader } from 'Common/PageHeader'
import { ChatWindow } from 'Common/ChatWindow'
import { ChatBubble } from 'Common/ChatBubble'
import { ChatInput } from 'Common/ChatInput'
import { Link } from 'react-router-dom'
import { sendAnalyticsEvent } from 'Common/Analytics'
import { sleep, isValidYoutubeLink } from 'Config/functions'
import { ConversionItem, OperationType, SourceType } from 'Contexts/General/Types/ConversionItem'
import { addToLocalHistory } from 'Utils/localStorageUtils'

export const SummarizeUrlToTxt = () => {
  const { t } = useTranslation()
  const [ConversionItem, setConversionItem] = useState<ConversionItem>()
  const [userMessage, setUserMessage] = useState<string>('')
  const [systemIsTyping, setSystemIsTyping] = useState<boolean>(false)
  const restartChatBubbles = [<ChatBubble content={t(`summarize-url.msg-02`)} />]
  const [chatBubbles, setChatBubbles] = useState<JSX.Element[]>([
    <ChatBubble content={t(`summarize-url.msg-01`)} />,
    ...restartChatBubbles,
  ])

  const getYoutubeInfo = async (url: string) => {
    if (!!ConversionItem?.title) return
    setSystemIsTyping(true)
    const res = await getYoutubeUrlInfo(url)
    if (res.error) {
      if (res?.error?.message) {
        await addMessage(res.error.message, true)
      } else {
        await addMessage(t(`general.error-wrong-try-again`), true)
        restart()
      }
      await sleep(300)
      restart()
    } else {
      const newItem: ConversionItem = {
        url: url,
        title: res.data.title,
        operationType: OperationType.TRANSCRIPTION,
        sourceType: SourceType.YOUTUBE,
        success: false,
        date: new Date().toISOString(),
      }
      setConversionItem((prev) => ({ ...prev, ...newItem }))
      await addMessage(t(`convert-url.msg-convert-received`) + ' ' + newItem.title, true)
      startConvert(newItem)
    }
  }
  const restart = () => {
    setSystemIsTyping(false)
    setConversionItem(undefined)
    setChatBubbles((prev) => [...prev, ...restartChatBubbles])
  }

  const startConvert = async (item: ConversionItem) => {
    if (!item?.url) return console.log('fayfay no url')
    try {
      const res = await youtubeToSummary(item.url)
      if (res.error || !res.data) throw new Error(res.error.message || 'Unknown error at startSummary')
      const newItem: ConversionItem = {
        ...item,
        resultFilePath: res.data.filePath,
        size: res.data.fileSize,
        title: res.data.fileName,
        sourceType: SourceType.YOUTUBE,
        operationType: OperationType.SUMMARY,
        success: true,
        date: new Date().toISOString(),
      }
      setConversionItem(newItem)
      displayDownloadLink(newItem)
    } catch (e: any) {
      console.error('startConvert Error:', e);
      await addMessage(t(`general.error-wrong-try-again`), true)
      restart()
    } finally {
      setSystemIsTyping(false)
    }
  }

  const displayDownloadLink = async (newItem: ConversionItem) => {
    if (!newItem?.resultFilePath) return
    await sleep(300)
    await addMessage(t(`general.success`), true)
    await sleep(300)
    setChatBubbles((prev) => [
      ...prev,
      <ChatBubble
        content={
          <span>
            {t(`convert-url.msg-convert-success`)}
            <Link to={`/downloads`} className="download-link">
              {newItem?.title}
            </Link>
          </span>
        }
        isSystem
      />,
    ])
    sendAnalyticsEvent({
      category: 'url',
      action: OperationType.CONVERSION,
      fileName: newItem?.resultFilePath,
    })
    setSystemIsTyping(false)
    addToLocalHistory(newItem)
  }

  const addMessage = async (newMsg: string | JSX.Element, isSystem: boolean | undefined = false) => {
    if (isSystem) await sleep(300)
    setChatBubbles((prev) => [...prev, <ChatBubble content={newMsg} isSystem={isSystem} />])
    const element = document.getElementById('scroll-ref')
    if (element) {
      window.scrollTo(0, window.scrollY - 1150)
    }
  }

  const sendUserMessage = async () => {
    const msg = userMessage
    setUserMessage('')
    if (!msg) return
    await addMessage(msg)
    if (!isValidYoutubeLink(msg)) {
      await addMessage(t(`general.invalid-yt-url`), true)
      return
    }
    if (!ConversionItem?.url) {
      setConversionItem((prev) => ({ ...prev, url: msg }))
      getYoutubeInfo(msg)
    }
  }

  return (
    <ConvertToMp3Wrapper>
      <PageHeader instructor={convertInstructor} title={t(`summarize-url.page-title`)} />
      <ChatWindow systemIsTyping={systemIsTyping} chatBubbles={chatBubbles} />
      <ChatInput
        videoUrl={ConversionItem?.url}
        userMessage={userMessage}
        setUserMessage={setUserMessage}
        sendUserMessage={sendUserMessage}
        restart={restart}
      />
    </ConvertToMp3Wrapper>
  )
}

const ConvertToMp3Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1100px) {
  }
`
